import type { History } from 'history';
import React, { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

interface Props {
  history: History;
  basename?: string;
  children?: React.ReactNode;
}

/**
 * Lets react-router v7 sync with an externally-created `history` instance so
 * that imperative navigation (history.push/replace) keeps working outside of
 * components. Replaces connected-react-router's <ConnectedRouter />.
 */
const HistoryRouter = ({ history, basename, children }: Props) => {
  const [state, setState] = useState({ action: history.action, location: history.location });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router basename={basename} location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
};

export default HistoryRouter;
